import gql from 'graphql-tag';

import client from '../graphqlAPI';

// The air times of the next `days` days (UTC instants; the manager shows them in Madrid time).
const GET_RADIO_UPCOMING_AIRINGS = gql`
  query getRadioUpcomingAirings($days: Int, $channel: Int) {
    getRadioUpcomingAirings(days: $days, channel: $channel) {
      isAuth
      airings {
        id
        date
        channel
        showId
        slug
        title { es ca en pt }
        parentTitle { es ca en pt }
        status
      }
    }
  }
`;

const getRadioUpcomingAirings = async ({ days, channel } = {}) => {
  try {
    const result = await client
      .query({
        query: GET_RADIO_UPCOMING_AIRINGS,
        errorPolicy: 'all',
        variables: { days, channel },
        fetchPolicy: 'no-cache',
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const {
      data: { getRadioUpcomingAirings: getRadioUpcomingAiringsData },
    } = result;

    if (getRadioUpcomingAiringsData) {
      return getRadioUpcomingAiringsData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: getRadioUpcomingAirings = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: getRadioUpcomingAirings Error: ${error}`);
    return null;
  }
};

export default getRadioUpcomingAirings;
